'use strict';

function AddPendingSpendingController(
    $scope,
    $mdDialog,
    pSpendingsPromise
) {
    'ngInject';

    pSpendingsPromise.$promise.then((pSpendings) => {
        $scope.pSpendings = pSpendings;
    });

    $scope.btnDisabled = true;

    $scope.getSpendings = function() {
        return pSpendingsPromise.$promise;
    };

    $scope.save = function() {
        $mdDialog.hide({
            pSpending: this.selectedPSpending
        });
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default AddPendingSpendingController;
